module.exports = __webpack_public_path__ + "static/media/PortalFranqueado.7c3b5cbf.webp";